import { calcImageUrl, getWidthByHeight } from '../../util';

import { RhinoImage, RhinoImageRatio } from './types';

type GetImageByRatioOptions = {
  imageHeight: number;
  imageType: number;
  imageRatio: RhinoImageRatio;
};

export function getImageByRatio(images: RhinoImage[], { imageHeight, imageType, imageRatio }: GetImageByRatioOptions) {
  const image = images.find((i) => i.type === imageType) ?? images.find((i) => i.ratio === imageRatio);

  if (!image) {
    return;
  }

  const width = getWidthByHeight(imageHeight, imageRatio);

  return {
    height: imageHeight,
    width,
    url: calcImageUrl(image.url, imageHeight, width),
  };
}
